import React from "react";
import countryList from "./countryOfResidence.json";
import countryCodes from "./countryCodes.json";
import bcloader from "../../../assets/images/bcloader.gif";
import { t } from "../../utils/i18n";

const Form = ({
  data,
  errors,
  handleSubmit,
  handleInputChange,
  closePopup,
}) => {

  // Helper function to prepend country code to the phone number
  const prependCountryCode = (code, phoneNumber) => {
    // Remove any existing country code from the phone number
    let cleanedPhoneNumber = phoneNumber.replace(/^\+\d+/, '');
    return `${code}${cleanedPhoneNumber}`;
  };

  // Modified handleChange function
  const handleChange = (e) => {
    const { name, value } = e.target;

    // Handle country code change
    if (name === "countryCode") {
      const selectedCountry = countryCodes.find(
        (countryCode) => countryCode.name === value
      );
      if (selectedCountry) {
        const newPhoneNumber = prependCountryCode(selectedCountry.code, data.phone_number);
        handleInputChange({ target: { name: "phone_number", value: newPhoneNumber } });
      }
    }

    handleInputChange(e);
  };

  return (
    <form id="broker-form">
      <h3 className="broker-title">{t("referrals.brokers.become")}</h3>
      <small class="broker-disclaimer">
        <span>
          <strong>{t("referrals.brokers.disclaimer_label")}</strong>{t("referrals.brokers.disclaimer")}
        </span>
      </small>
      
      {/* Notifications for Loader, Error. Loader changes to Successful from JS side etc) */}
      <div id="form-status-cont">
        <div id="form-status-section">

            <div>
              <h3 id="formstatus-popup-title-text">
                  <div>
                    <img src={bcloader} alt={t("referrals.brokers.loader")}/>
                  </div>
              </h3>
            </div>

            <div id="form-success-button">
              <a 
              className="broker-success-btn"
              href="/p2p_trades/offers/new">
              <button
              type="button">
                {t("referrals.brokers.okay")}
              </button>
              </a>
            </div>
        </div>
      </div>

      <div id="form-error-cont">
        <div id="broker-error-section">
            <div class="error-popup-title">
              <button
              type="button"
              onClick={closePopup}
              id="broker-popup-closebtn">
                <span class="material-symbols-outlined">close</span>
              </button>
            </div>
            <div>
            <h3 class="error-popup-title-text">
                {t("referrals.brokers.failed")}
              </h3>
            </div>
          <div id="form-error-message">
  
          </div>
        </div>
      </div>

      {/* FORM */}
      <div className="form-group broker-field">
        <label htmlFor="first_name">
          {t("referrals.brokers.first_name")} <span style={{ color: "red" }}>*</span>
          <br/>
          <small className="text-muted">
            {t("referrals.brokers.use_bank_name")}
          </small>
        </label>
        <input
          type="text"
          name="first_name"
          id="first-name-input"
          className="broker-input"
          required
          value={data.first_name}
          onChange={handleInputChange}
        />
        {errors.first_name && (
          <small className="text-danger">{errors.first_name}</small>
        )}
      </div>
  
      <div className="form-group broker-field">
        <label htmlFor="middle_name">
          {t("referrals.brokers.middle_name")}
          <br/>
          <small className="text-muted">
            {t("referrals.brokers.use_bank_name")}
          </small>
        </label>
        <input
          type="text"
          name="middle_name"
          id="middle-name-input"
          className="broker-input"
          value={data.middle_name}
          onChange={handleInputChange}
        />
        {errors.middle_name && (
          <small className="text-danger">{errors.middle_name}</small>
        )}
      </div>
  
      <div className="form-group broker-field">
        <label htmlFor="last_name">
          {t("referrals.brokers.last_name")} <span style={{ color: "red" }}>*</span>
          <br/>
          <small className="text-muted">
            {t("referrals.brokers.use_bank_name")}
          </small>
        </label>
        <input
          type="text"
          name="last_name"
          id="last-name-input"
          className="broker-input"
          required
          value={data.last_name}
          onChange={handleInputChange}
        />
        {errors.last_name && (
          <small className="text-danger">{errors.last_name}</small>
        )}
      </div>
  
      <div className="form-group broker-field">
        <label htmlFor="business_name">{t("referrals.brokers.business_name")}
          <br/>
          <small className="text-muted">
            {t("referrals.brokers.use_bank_name")}
          </small>
        </label>
        <input
          type="text"
          name="business_name"
          id="business-name-input"
          className="broker-input"
          value={data.business_name}
          onChange={handleInputChange}
        />
        {errors.business_name && (
          <small className="text-danger">{errors.business_name}</small>
        )}
      </div>
  
      <div className="form-group broker-field">
        <label htmlFor="email">
          {t("referrals.brokers.email")} <span style={{ color: "red" }}>*</span>
        </label>
        <input
          type="email"
          name="email"
          id="email-input"
          className="broker-input"
          required
          value={data.email}
          onChange={handleInputChange}
        />
        {errors.email && <small className="text-danger">{errors.email}</small>}
      </div>
  
      <div>
        <br/>
        <p><strong>{t("referrals.brokers.phone_number")}</strong> <span style={{ color: "red" }}>*</span></p>
        <small className="text-muted">{t("referrals.brokers.phone_hint")}</small>
        <div className="form-group row broker-field">
          <div className="col-md-4">
            <label htmlFor="countryCode">
              {t("referrals.brokers.country_code")}
            </label>
            <select
              name="countryCode"
              className="form-control broker-dropdown"
              id="country-code-select"
              value={data.countryCode}
              onChange={handleChange}
              required
            >
              {countryCodes.map((countryCode, index) => (
                <option key={index} value={countryCode.name}>
                  {countryCode.name}
                </option>
              ))}
            </select>
          </div>
    
          <div className="col-md-8">
            <label htmlFor="phone_number">
              {t("referrals.brokers.number")}
            </label>
            <input
              type="tel"
              name="phone_number"
              className="form-control broker-input"
              id="phone-number-input"
              required
              value={data.phone_number}
              onChange={handleChange}
            />
            {errors.phone_number && (
              <small className="text-danger">{errors.phone_number}</small>
            )}
          </div>
        </div>
        <br/>
      </div>
  
      <div className="form-group broker-field">
        <label htmlFor="gender">
          {t("referrals.brokers.gender")} <span style={{ color: "red" }}>*</span>
        </label>
        <select
          name="gender"
          className="form-control broker-dropdown"
          required
          value={data.gender}
          onChange={handleInputChange}
        >
          <option value="Male">{t("referrals.brokers.male")}</option>
          <option value="Female">{t("referrals.brokers.female")}</option>
        </select>
      </div>
  
      <div className="form-group broker-field">
        <label htmlFor="country">
          {t("referrals.brokers.country_residence")} <span style={{ color: "red" }}>*</span>
          <br/>
          <small className="text-muted">{t("referrals.brokers.country_hint")}</small>
        </label>
        <select
          name="country"
          className="form-control broker-dropdown"
          id="country-select"
          value={data.country}
          onChange={handleInputChange}
          required
        >
          {countryList.map((country, index) => (
            <option key={index} value={country.name}>
              {country.name}
            </option>
          ))}
        </select>
      </div>
  
      <div className="form-group broker-field">
        <label htmlFor="min_deposit">
          {t("referrals.brokers.min_deposit")} <span style={{ color: "red" }}>*</span>
          <br/>
          <small className="text-muted">{t("referrals.brokers.min_hint")}</small>
        </label>
        <input
          placeholder={t("referrals.brokers.placeholder_gt0")}
          type="number"
          name="min_deposit"
          id="min-deposit-input"
          className="broker-input"
          required
          value={data.min_deposit}
          onChange={handleInputChange}
        />
      </div>
  
      <div className="form-group broker-field">
        <label htmlFor="max_deposit">
          {t("referrals.brokers.max_deposit")} <span style={{ color: "red" }}>*</span>
          <br/>
          <small className="text-muted">{t("referrals.brokers.max_hint")}</small>
        </label>
        <input
          type="number"
          placeholder={t("referrals.brokers.placeholder_gt0")}
          name="max_deposit"
          id="max-deposit-input"
          className="broker-input"
          required
          value={data.max_deposit}
          onChange={handleInputChange}
        />
        {errors.depositWarning && (
          <small className="text-danger">{errors.depositWarning}</small>
        )}
      </div>
  
      <div className="form-group broker-field">
        <label htmlFor="proof_of_address">
          {t("referrals.brokers.proof_of_address")} <span style={{ color: "red" }}>*</span>
          <br/>
          <small className="text-muted">{t("referrals.brokers.proof_hint")}</small>
        </label>
        <input
          type="file"
          name="proof_of_address"
          id="proof-of-address-input"
          className="broker-input"
          accept=".png, .jpeg, .jpg, .pdf"
          required
          onChange={handleInputChange}
        />
        <small className="text-muted">{t("referrals.brokers.formats")}</small>
      </div>
  
      <div className="form-group broker-field">
        <label htmlFor="bank_statement">
          {t("referrals.brokers.bank_statement")} <span style={{ color: "red" }}>*</span>
          <br/>
          <small className="text-muted">{t("referrals.brokers.bank_hint")}</small>
        </label>
        <input
          type="file"
          name="bank_statement"
          id="bank-statement-input"
          className="broker-input"
          accept=".png, .jpeg, .jpg, .pdf"
          required
          onChange={handleInputChange}
        />
        <small className="text-muted">{t("referrals.brokers.formats")}</small>
      </div>
  
      <button
        type="submit"
        className="btn submit-btn broker-btn"
        onClick={(e) => handleSubmit(e)}
      >
        <p id="submit-broker-request">{t("referrals.brokers.submit")}</p>
      </button>
    </form>   
  )
}

export default Form;
